import { FC } from 'react';
import { FormikProps } from 'formik';

import { IChangeOfVehiclePart2 } from '@acorn-portal/shared/src/models/midTermAdjustment-model';
import RadioGroupButton from '@acorn-portal/shared/src/components/inputs/radio-button-group';
interface IProps {
	formik: FormikProps<IChangeOfVehiclePart2>;
}

const TelematicQuestions: FC<IProps> = ({ formik }) => {
	return (
		<RadioGroupButton
			label='Do you still have your telematics device?'
			name='telematicsBox'
			id='telematicsBox'
			value={formik.values.telematicsBox}
			onChange={(value) => formik.setFieldValue('telematicsBox', value)}
			error={formik.touched.telematicsBox && Boolean(formik.errors.telematicsBox)}
			helperText={formik.touched.telematicsBox && formik.errors.telematicsBox}
		/>
	);
};

export default TelematicQuestions;
